import { render, staticRenderFns } from "./SpecialAreaSelect.vue?vue&type=template&id=56d3aefc&"
import script from "./SpecialAreaSelect.vue?vue&type=script&lang=js&"
export * from "./SpecialAreaSelect.vue?vue&type=script&lang=js&"
import style0 from "./SpecialAreaSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports